import { createContext, ReactNode, useReducer } from 'react';
import { IGeneralDialogProps } from '.';

interface IUseConfirmationDialog {
    props: IGeneralDialogProps;
    setDialogProps: (props: Partial<IGeneralDialogProps>) => void;
    patchDialogProps: (props: Partial<IGeneralDialogProps>) => void;
    clearDialogProps: () => void;
}

const initialConfirmationDialogProps: IGeneralDialogProps = {
    openDialog: false,
    style: {},
    title: '',
    contentText: '',
    content: <></>,
    actions: [],
};

function reducer(
    state: IGeneralDialogProps,
    action: {
        type: 'patch' | 'set' | 'clear';
        partialState?: Partial<IGeneralDialogProps>;
    }
) {
    switch (action.type) {
        case 'patch':
            return { ...state, ...action.partialState };
        case 'set':
            return {
                ...initialConfirmationDialogProps,
                ...action.partialState,
            };
        case 'clear':
            return initialConfirmationDialogProps;
        default:
            throw new Error();
    }
}

export const GeneralDialogContext = createContext<IUseConfirmationDialog>(
    {} as IUseConfirmationDialog
);

export const GeneralDialogProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const [props, dispatch] = useReducer(
        reducer,
        initialConfirmationDialogProps
    );

    const setDialogProps = (partialState: Partial<IGeneralDialogProps>) => {
        dispatch({ type: 'set', partialState });
    };

    const patchDialogProps = (partialState: Partial<IGeneralDialogProps>) => {
        dispatch({ type: 'patch', partialState });
    };

    const clearDialogProps = () => {
        dispatch({ type: 'clear' });
    };

    const value = {
        props,
        setDialogProps,
        patchDialogProps,
        clearDialogProps,
    };

    return (
        <GeneralDialogContext.Provider value={value}>
            {children}
        </GeneralDialogContext.Provider>
    );
};
